import { ExistingAppointmentUi } from "ui";
import useCheckInAppointment from "../../../apis/tryst/check-in-appointment";
import useGetPatientOverview from "../../../apis/tryst/use-get-patient-overview";
import useQueueStore from "../../../stores/queue-store";
import { getQueueTypeFromStatus } from "../../../utils/appointment-utils";
import getBridges from "../../../utils/bridges/get-bridges";

const NewAptExistingAppointment = () => {
  const setClinicId = useQueueStore((state) => state.setClinicId);
  const selectedPatient = useQueueStore((state) => state.selectedPatient);
  const setSelectedDate = useQueueStore((state) => state.setSelectedDate);
  const setScrollToValues = useQueueStore((state) => state.setScrollToValues);

  const { data } = useGetPatientOverview({
    patientId: selectedPatient?.oid!,
  });

  const { mutateAsync: putCheckInAppointment, isLoading } =
    useCheckInAppointment();

  if (!selectedPatient || !data?.upcoming_appointment) return null;

  const { upcoming_appointment } = data;

  const handleCheckinClick = async () => {
    const { success } = await putCheckInAppointment({
      appointment: upcoming_appointment,
    });
    if (success) {
      setSelectedDate(new Date());
    }
  };

  const handleGoToAptClick = () => {
    const { date, status, aid, clinic_id } = upcoming_appointment;
    setSelectedDate(new Date(date));
    const queueType = getQueueTypeFromStatus(status);
    let queueTypeParams = "";
    if (queueType === "checkin" || queueType === "completed") {
      queueTypeParams = `right=${queueType}`;
    } else {
      queueTypeParams = `left=${queueType}`;
    }

    setScrollToValues({ aid, queueType });
    getBridges().navigate(
      "replace",
      `/app/appointments/clinic/${clinic_id}/queue${
        queueType ? `?${queueTypeParams}` : ""
      }`
    );
    setClinicId(clinic_id);
  };

  return (
    <div className="dr-pr-12 dr-py-8 dr-pl-98">
      <ExistingAppointmentUi
        apt={upcoming_appointment}
        onCheckinClick={handleCheckinClick}
        onGoToAptClick={handleGoToAptClick}
        isCheckinLoading={isLoading}
      />
    </div>
  );
};

export default NewAptExistingAppointment;
